module.exports = __webpack_public_path__ + "img/blog-shape-1.c871d03b.png";